/**
 * Keep the useful provider-missing guard while creating the Error at the point where the default
 * value is actually read. The upstream package constructs one Error eagerly when the context module
 * loads, so every later failure misleadingly points at `createContext(defaultError(...))` and hides
 * the component or module that accessed the context outside its provider.
 */
export function defaultError(contextName, options = {}) {
  const errorMessage =
    options.errorMessage ?? `${contextName} can only be accessed within a <${contextName}Provider>`;
  const throwError = () => {
    throw new Error(errorMessage);
  };

  return new Proxy(throwError, {
    apply: throwError,
    construct: throwError,
    defineProperty: throwError,
    deleteProperty: throwError,
    get: throwError,
    getOwnPropertyDescriptor: throwError,
    getPrototypeOf: throwError,
    has: throwError,
    ownKeys: throwError,
    preventExtensions: throwError,
    set: throwError,
    setPrototypeOf: throwError,
  });
}
